
    var doc = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getGlobalRegistrationPageData"},"variableDefinitions":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fetch"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Common"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"Page"},"name":{"kind":"Name","value":"GlobalRegistrationPage"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Active"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Subtitle"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"TitleColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Closed"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"SubtitleColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"BackgroundColor"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ComingSoon"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Open"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"BackgroundImage"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"src"},"arguments":[],"directives":[]}]}},{"kind":"Field","alias":{"kind":"Name","value":"Continents"},"name":{"kind":"Name","value":"RegistrationContinents"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"Name"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"Countries"},"name":{"kind":"Name","value":"RegistrationCountries"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"Name"},"name":{"kind":"Name","value":"CountryName"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"Link"},"arguments":[],"directives":[]},{"kind":"Field","alias":{"kind":"Name","value":"Status"},"name":{"kind":"Name","value":"Active"},"arguments":[],"directives":[]}]}}]}}]}}]}}]}}]}}],"loc":{"start":0,"end":527}};
    doc.loc.source = {"body":"query getGlobalRegistrationPageData {\n  fetch {\n    Common {\n      Page: GlobalRegistrationPage {\n        Active\n        Title\n        Subtitle\n        TitleColor\n        Closed\n        SubtitleColor\n        BackgroundColor\n        ComingSoon\n        Open\n        BackgroundImage {\n          src\n        }\n        Continents: RegistrationContinents {\n          Name\n          Countries: RegistrationCountries {\n            Name: CountryName\n            Link\n            Status: Active\n          }\n        }\n      }\n    }\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set(opRefs);
      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }

    module.exports = doc;
    
        module.exports["getGlobalRegistrationPageData"] = oneQuery(doc, "getGlobalRegistrationPageData");
        



//////////////////
// WEBPACK FOOTER
// ./src/apollo/queries/getGlobalRegistrationPageData.gql
// module id = 864
// module chunks = 0